const CITY_COMPONENTS = [
	{ types: ['locality'], property: 'short_name' },
	{ types: ['postal_town'], property: 'short_name' },
	{ types: ['sublocality_level_1', 'sublocality'], property: 'short_name' },
	{ types: ['administrative_area_level_2'], property: 'long_name' },
	{ types: ['administrative_area_level_1'], property: 'long_name' }
]

export function getCityFromAddressComponents (addressComponents) {
	if (!Array.isArray(addressComponents)) {
		return null
	}

	for (const { types, property } of CITY_COMPONENTS) {
		for (const type of types) {
			const component = addressComponents.find(c => c?.types?.includes(type))

			if (component) {
				return component[property] || component.short_name || component.long_name || null
			}
		}
	}

	return null
}

export function getCityFromPlace (placeResultData) {
	return getCityFromAddressComponents(placeResultData?.address_components)
}

export function getCountryComponentFromPlace (placeResultData) {
	return placeResultData?.address_components?.find(c => c?.types?.includes('country')) || null
}
